<template>
  <div class="accountSetting">
    <el-container>
      <el-header>
        <el-form ref="form" :model="form" label-width="60px" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="用户账号" prop="name">
                <el-input
                  v-model="form.name"
                  autocomplete="off"
                  :onkeyup="
                    (form.name = form.name.replace(/[\u4E00-\u9FA5]/g, ''))
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="员工姓名" prop="displayName">
                <el-input
                  v-model="form.displayName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="员工工号" prop="jobNo">
                <el-input v-model="form.jobNo" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>

            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属组织" prop="orgId">
                  <el-select v-model="form.orgId" @change="getDeptList">
                    <el-option
                      :label="post.name"
                      :value="post.id"
                      v-for="post in GovList"
                      :key="post.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="部门" prop="deptId">
                  <el-cascader
                    v-model="form.deptId"
                    :options="allDeptList"
                    :props="defaultProps"
                    change-on-select
                    style="width: 100%"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </div>
            <!-- <el-col :span="6">
            <el-form-item label="岗位" prop="jobIdSet">
              <el-select v-model="form.jobIdSet">
                <el-option
                  :label="delFlag.delFlagName"
                  :value="delFlag.delFlag"
                  v-for="delFlag in delFlagList"
                  :key="delFlag.delFlag"
                ></el-option>
              </el-select>
            </el-form-item>
            </el-col>-->

            <el-col :span="showAdvanceFilter ? 12 : 6">
              <div class="handlePanel">
                <el-button type="primary" @click="selectClick()"
                  >查询</el-button
                >
                <el-button type="info" @click="resetClick()">重置</el-button>
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <div style="clear: both"></div>
        <el-row>
          <el-col :span="24">
            <div class="operatePanel">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addUserClick()"
                v-if="btnAuthorize.addBtn.btnEnable"
                >新增账号</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="updateUserClick()"
                v-if="btnAuthorize.modifyBtn.btnEnable"
                >修改账号</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-delete"
                @click="deleteUserClick()"
                v-if="btnAuthorize.delBtn.btnEnable"
                >删除账号</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-lock"
                @click="updatePwdClick()"
                v-if="btnAuthorize.pwdBtn.btnEnable"
                >修改密码</el-button
              >
              <!-- <el-button
                type="primary"
                icon="el-icon-user"
                @click="roleAssign()"
                v-if="btnAuthorize.roleBtn.btnEnable"
              >指派角色</el-button>
              <el-button
                type="primary"
                icon="el-icon-service"
                @click="postAssign()"
                v-if="btnAuthorize.postBtn.btnEnable"
              >设置岗位</el-button>
              <el-button
                type="primary"
                icon="el-icon-office-building"
                @click="deptAssign()"
                v-if="btnAuthorize.deptBtn.btnEnable"
              >设置部门</el-button>-->
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="accountList"
          highlight-current-row
          @current-change="handleSelectionChange"
          @row-click="rowClicked"
          size="mini"
          height="100%"
          border
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="用户账号"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="displayName"
            label="员工姓名"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="jobNo"
            label="员工工号"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="deptDisplayName"
            label="所属部门"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="jobDisplayName"
            label="岗位"
            :show-overflow-tooltip="true"
            width="90"
          ></el-table-column>
          <!-- <el-table-column prop="sex" label="性别" :show-overflow-tooltip="true" width="50">
            <template slot-scope="props">{{props.row.sex==1?'男':'女'}}</template>
          </el-table-column>-->
          <el-table-column
            prop="statusDisplayName"
            label="启用状态"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="email"
            label="电子邮件"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="openUploadSign(scope.row)"
                >上传电子签名</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.signUrl"
                @click="previewSign(scope.row)"
                >查看签名</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="form.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 新增/修改账号弹窗 -->
    <div class="addDialog">
      <el-dialog
        class="dialog816"
        :title="isAddFlag ? '新增账号' : '修改账号信息'"
        :visible.sync="isAddDialogShow"
        :before-close="closeAddDialog"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addForm"
          label-width="100px"
          ref="addForm"
          :rules="addRules"
        >
          <el-row>
            <el-col :span="11">
              <el-form-item label="用户账号" prop="name">
                <el-input
                  v-model="addForm.name"
                  autocomplete="off"
                  :onkeyup="
                    (addForm.name = addForm.name.replace(
                      /[\u4E00-\u9FA5]/g,
                      ''
                    ))
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="用户密码" prop="password" v-if="isAddFlag">
                <el-input
                  v-model="addForm.password"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="员工姓名" prop="displayName">
                <el-input
                  v-model="addForm.displayName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="员工工号" prop="jobNo">
                <el-input v-model="addForm.jobNo" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="addForm.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="电子邮件" prop="email">
                <el-input v-model="addForm.email" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="所属组织" prop="orgId">
                <el-select v-model="addForm.orgId" @change="getDeptList">
                  <el-option
                    :label="post.name"
                    :value="post.id"
                    v-for="post in GovList"
                    :key="post.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="是否管理员">
                <el-select
                  v-model="addForm.isAdmin"
                  :disabled="addForm.type == 'wechat'"
                >
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
           
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="所属岗位" prop="jobIdSet">
                <el-select
                  v-model="addForm.jobIdSet"
                  multiple
                  @change="$forceUpdate()"
                >
                  <el-option
                    :label="post.name"
                    :value="post.id"
                    v-for="post in PostList"
                    :key="post.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-for="(item, index) in deptIds" :key="index">
            <el-col :span="11">
              <el-form-item label="所属部门">
                <!-- <el-select v-model="addForm.deptId">
                  <el-option
                    :label="dept.specialFlagName"
                    :value="dept.specialFlag"
                    v-for="dept in specialFlagList"
                    :key="dept.specialFlag"
                  ></el-option>
                </el-select>-->
                <el-cascader
                  v-model="item.deptId"
                  :options="subDeptList"
                  :props="defaultProps"
                  :placeholder="item.name"
                  change-on-select
                  style="width: 100%"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="margin-left: 10px; margin-top: 12px">
              <!-- <div class="checkboxWrap"> -->
              <el-checkbox
                v-model="item.main"
                :label="index"
                @input="changeValue(index)"
                >默认
              </el-checkbox>
              <!-- </div> -->
            </el-col>
            <el-col :span="3" style="margin-left: 10px; margin-top: 12px">
              <!-- <div class="checkboxWrap"> -->
              <el-checkbox v-model="item.isResponse" :label="index"
                >部门负责人
              </el-checkbox>
              <!-- </div> -->
            </el-col>
            <el-col
              :span="1"
              v-if="index === deptIds.length - 1"
              style="margin-left: 10px; margin-top: 8px"
            >
              <el-button
                icon="el-icon-plus"
                size="mini"
                circle
                @click="addDeptItem()"
              ></el-button
            ></el-col>
            <el-col
              :span="1"
              v-if="deptIds.length != 1"
              style="margin-left: 10px; margin-top: 8px"
            >
              <el-button
                icon="el-icon-minus"
                size="mini"
                circle
                @click="delDeptItem(index)"
              ></el-button
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="11" v-if="false">
              <el-form-item label="备注">
                <el-input
                  v-model="addForm.remark"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" v-if="false">
              <el-form-item label="状态" prop="status">
                <el-select v-model="addForm.status">
                  <el-option
                    :label="sex.sexName"
                    :value="sex.sex"
                    v-for="sex in sexList"
                    :key="sex.sex"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="closeAddDialog">取 消</el-button>
          <el-button type="primary" @click="saveUserClick()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 密码修改账号弹窗 -->
    <PwdSetting ref="PwdSetting" />
    <AccountRoleAssignDialog
      ref="AccountRoleAssignDialog"
    ></AccountRoleAssignDialog>
    <el-dialog
      title="电子签名"
      :visible.sync="uploadSignVisible"
      :before-close="uploadSignBeforeClose"
    >
      <div>
        <input
          ref="input"
          type="file"
          name="image"
          accept="image/*"
          @change="setImage"
        />

        <div class="content-box">
          <section class="cropper-area">
            <div class="img-cropper">
              <vue-cropper
                v-if="imgSrc"
                ref="cropper"
                :aspect-ratio="16 / 9"
                :src="imgSrc"
                :containerStyle="containerStyle"
                :imgStyle="imgStyle"
              />
              <div
                v-else
                class="empty-cropper"
                @click.prevent="showFileChooser"
              >
                <p>点击上传图片</p>
              </div>
            </div>

            <div class="actions">
              <a href="#" role="button" @click.prevent="rotate(90)"> 旋转 </a>
              <a ref="flipX" href="#" role="button" @click.prevent="flipX">
                左右翻转
              </a>
              <a ref="flipY" href="#" role="button" @click.prevent="flipY">
                上下翻转
              </a>
              <a href="#" role="button" @click.prevent="cropImage"> 截图 </a>
              <a href="#" role="button" @click.prevent="reset"> 重置 </a>
              <!-- <a href="#" role="button" @click.prevent="showFileChooser">
                选择图片
              </a> -->
              <a href="#" role="button" @click.prevent="clearCrop"> 清空 </a>
            </div>
          </section>
          <section class="preview-area">
            <!-- <p>电子签名:</p> -->
            <div class="cropped-image">
              <img v-if="cropImg" :src="cropImg" alt="Cropped Image" />
              <div v-else class="crop-placeholder" />
            </div>
          </section>
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button @click="closeUploadSign" type="info">关闭</el-button>
        <el-button type="primary" @click="doUploadSign">上传</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看电子签名"
      :visible.sync="previewSignVisible"
      width="400px"
    >
      <div style="display: flex; justify-content: center; align-items: center">
        <img
          style="
            display: block;
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
            border: 1px solid #eaeaf4;
          "
          v-if="previewSignUrl"
          :src="previewSignUrl"
          alt=""
        />
        <div v-else>no image</div>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="previewSignVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import Constants from "@/utils/consts";
import {
  getSysUserAccountService,
  addSysUserService,
  deleteSysUserService,
  modifySysUserService,
  saveSign,
  getSign,
} from "../../services/basicDataService";
import {
  getsubDeptService, //子部门列表
  getDeptListService, //根据组织获取部门列表
  manangerStationService, //获取岗位列表
  getOrgIdService, //获取某条用户详情
  getGovService, //组织列表
  uploadSignService,
} from "../../services/sysSettingService";

import AccountRoleAssignDialog from "../../components/systemSetting/AccountRoleAssignDialog";
import PwdSetting from "../../components/systemSetting/resetPwdSetting";
export default {
  name: "AccountSetting",
  components: {
    AccountRoleAssignDialog,
    PwdSetting,
    VueCropper,
  },
  data() {
    return {
      previewSignVisible: false,
      previewSignUrl: "", // 要预览的电子签名
      uploadSignVisible: false,
      imgSrc: "",
      cropImg: "",
      containerStyle: {
        height: "300px",
      },
      imgStyle: {
        display: "block",
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%",
        visibility: "hidden",
      },
      total: 0, //总数
      userList: [], //选中的账号列表
      accountList: [], //用户列表
      deptList: [], //部门列表
      PostList: [], //岗位列表
      GovList: [], //组织列表
      showAdvanceFilter: false, //是否展开高级搜索
      //账号状态列表
      delFlagList: [
        { delFlagName: "全部", delFlag: null },
        { delFlagName: "正常", delFlag: 0 },
        { delFlagName: "已冻结", delFlag: 1 },
      ],
      //状态列表
      sexList: [
        { sexName: "禁用", sex: "0" },
        { sexName: "启用", sex: "1" },
      ],

      isScreenShow: false, //高级筛选显示开关
      isAddDialogShow: false, //新增/修改用户显示开关
      isAddFlag: true, //新增/修改标识
      isPwdDialogShow: false, //密码修改弹窗开关
      isDeptDialogShow: false, //部门设置弹窗开关
      form: {
        // operationFlag: 0,
        name: "",
        phone: "",
        orgId: "",
        displayName: "",
        jobNo: "",
        jobId: "",
        deptId: "",
        pageIndex: 1,
        pageSize: 20,
      },
      deptIds: [{ deptId: [], main: true, isResponse: false }],
      addForm: {
        name: "",
        password: "",
        displayName: "",
        jobNo: "",
        phone: "",
        email: "",
        deptId: "",
        deptList: [],
        jobIdSet: [],
        isAdmin: 0,
        jobId: 1,
        orgId: "",
        status: "1",
        remark: "",
      },
      allDeptList: [], //查询条件获取全部部门列表
      subDeptList: [], //根据组织获取部门列表
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      addRules: {
        name: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "输入内容长度必须介于1到16之间",
            trigger: "blur",
          },
        ],
        displayName: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "输入内容长度必须介于1到16之间",
            trigger: "blur",
          },
        ],
        jobNo: [
          { required: true, message: "请输入员工工号", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "输入内容长度必须介于1到16之间",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "输入内容长度必须介于6到16之间",
            trigger: "blur",
          },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/,
            message: "包含字母和数字中的至少一位",
            trigger: "blur",
          },
        ],
        orgId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
        // userNickName: [{ required: true, message: "请输入用户昵称" }],
        deptId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
        jobIdSet: [
          { required: true, message: "请选择所属岗位", trigger: "change" },
        ],
        // idCard: [
        //   {
        //     pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
        //     message: "请输入正确的身份证号码"
        //   }
        // ],
        email: [
          {
            pattern: /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
            message: "请输入正确的电子邮件",
          },
        ],
        phone: [
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" },
        ],
        userAccnt: [
          { required: true, message: "请输入用户账号" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" },
        ],
      },
      pwdForm: {
        pwd: "",
        pwdConform: "",
      },
      limitCount: 1, //头像数量
      fileList: [],
      //按钮权限
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        pwdBtn: { key: "pwdBtn", btnEnable: true },
        // roleBtn: { key: "2017111518093018774", btnEnable: true },
        // postBtn: { key: "2017111518100482429", btnEnable: true },
        // deptBtn: { key: "2017111518104230294", btnEnable: true }
      },
    };
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  methods: {
    changeValue(index) {
      if (!this.deptIds[index].main) {
        this.deptIds[index].main = false;
        this.$set(this.deptIds, index, this.deptIds[index]);

        this.addForm.deptId = "";
      } else {
        this.deptIds.forEach((item) => {
          item.main = false;
        });
        this.deptIds[index].main = true;
        this.$set(this.deptIds, index, this.deptIds[index]);

        this.addForm.deptId = this.deptIds[index].id;
      }
      // this.deptIds.push({})
      // this.deptIds.pop()
      // this.$forceUpdate()
    },
    uploadSignBeforeClose(done) {
      try {
        this.clearCrop();
      } catch (error) {
        console.log("--=", error);
      }
      done();
    },
    previewSign(row) {
      this.previewSignUrl = "";
      getSign({
        signUserId: row.id,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.previewSignUrl = res.data;
            this.previewSignVisible = true;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openUploadSign(row) {
      this.targetUploadSign = row;
      this.uploadSignVisible = true;
    },
    closeUploadSign() {
      this.clearCrop();
      this.uploadSignVisible = false;
    },
    doUploadSign() {
      try {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const formData = new FormData();
          // Pass the image file name as the third parameter if necessary.

          formData.append("file", blob, "sign.jpeg");
          uploadSignService(formData)
            .then((res) => {
              if (res.code == Constants.Code_OK) {
                let { fileName, path } = res.data;
                // 把path传给后台
                return saveSign({
                  id: this.targetUploadSign.id,
                  signUrl: path,
                });
              } else {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              }
            })
            .then((res) => {
              if (res.code == Constants.Code_OK) {
                this.uploadSignVisible = false;
                this.clearCrop();
                this.$alert("上传成功", "提示");
                this.getSysUserAccount();
              } else {
                this.$alert(res.msg, "提示");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }, "image/jpeg");
      } catch (error) {
        this.$alert("请先选择要上传的签名图片", "提示");
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute("data-scale", scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute("data-scale", scale);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setImage(e) {
      const file = e.target.files[0];

      if (file.type.indexOf("image/") === -1) {
        this.$message.error("只能选择图片");
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          if (this.$refs.cropper) {
            this.$refs.cropper.replace(event.target.result);
          }
        };

        reader.readAsDataURL(file);
      } else {
        this.$alert("当前浏览器不支持该功能", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    clearCrop() {
      if (this.$refs.cropper) {
        this.$refs.cropper.clear();
      }
      this.imgSrc = "";
      this.cropImg = null;
    },

    //---------

    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.form.pageIndex = 1;
        this.form.pageSize = 20;
      }
      this.addForm.deptList = [];
      this.addForm.deptId = 0;
      this.getSysUserAccount();
      // this.getsubListData();
      // this.getUserOneLevelJob();
      this.getGovListData(); //获取组织列表
    },
    /* 获取用户列表 */
    getSysUserAccount() {
      // this.form.operator = sessionStorage.getItem("userCode");
      let str = this.form.deptId;
      if (str.length > 0) {
        let len = str.length;
        this.form.deptId = str[len - 1];
      }
      getSysUserAccountService(this.form).then(
        (res) => {
          if (res.code == 10000000) {
            this.total = res.total;
            this.accountList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },

    //获取组织数据列表
    getGovListData() {
      let reqParam = {
        pageIndex: 1,
        pageSize: 100,
      };
      getGovService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.GovList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    getDeptList(val) {
      this.addForm.orgId = val;
      // this.addForm.jobIdSet = [];
      // this.form.orgId = val;
      this.getAllDeptData(val);
      this.getsubListData(val);
      this.getUserOneLevelJob(val);
    }, //

    //获取全部部门列表
    getAllDeptData(deptId) {
      if (this.addForm.orgId != "") {
        let reqParam = {
          pid: 0,
          orgId: deptId,
        };
        getDeptListService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              // this.total = res.total;
              this.allDeptList = res.data;
              this.allDeptList.forEach((item) => {
                item.leaf = item.isLeaf == 1;
              });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert(err, "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        this.$alert("请先选择查询组织", "提示", {
          confirmButtonText: "确定",
        });
      }
    },

    //根据组织获取一级部门下拉列表数据
    getsubListData(deptId) {
      if (this.addForm.orgId != "") {
        let reqParam = {
          pid: 0,
          orgId: deptId,
        };
        getDeptListService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              // this.total = res.total;
              this.subDeptList = res.data;
              this.subDeptList.forEach((item) => {
                item.leaf = item.isLeaf == 1;
              });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert(err, "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        this.$alert("请先选择所属组织", "提示", {
          confirmButtonText: "确定",
        });
      }
    },

    /* 新增用户请求 */
    addSysUser() {
      this.addForm.createUserId = sessionStorage.getItem("currentUserId");
      let flag = false;
      let s = {};
      this.addForm.deptList = this.deptIds.map((item) => {
        s = {};
        if (item.deptId.length > 0) {
          let len = item.deptId.length;
          if (item.main) this.addForm.deptId = item.deptId[len - 1];
          s.deptId = item.deptId[len - 1];
          s.isResponse = item.isResponse ? 1 : 0;
          return s;
        } else {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning("请选择部门");
        return;
      }
      if (this.addForm.deptId == 0) {
        this.$message.warning("请选择默认部门");
        return;
      }

      addSysUserService(this.addForm).then(
        (res) => {
          if (res.code == 10000000) {
            this.$alert("账号添加成功", "提示", {
              confirmButtonText: "确定",
            });
            this.$refs.addForm.resetFields();
            this.isAddDialogShow = false;
            this.getSysUserAccount();
          } else if (res.code >= 20000000) {
            this.$confirm(res.msg, "提示").then(() => {
              this.addForm.userCode = res.data.userCode;
              this.modifySysUser();
            });
          } else {
            this.$message.error("系统异常");
          }
        },
        (err) => {
          this.$message.error(err);
        }
      );
    },
    /* 修改用户请求 */
    modifySysUser() {
      // this.addForm.updateUserId = sessionStorage.getItem("currentUserId");
      this.addForm.deptId = "";
      let flag = false;
      if (this.addForm.deptId == this.userList[0].deptDisplayName) {
        this.addForm.deptId = this.addForm.pid;
      } else if (this.deptIds.length > 0) {
        // let len = this.addForm.deptIds.length;
        // this.addForm.deptId = this.addForm.deptId[len - 1];
        let s = {};
        this.addForm.deptList = this.deptIds.map((item) => {
          s = {};
          if (item.deptId.length > 0) {
            let len = item.deptId.length;
            if (item.main) this.addForm.deptId = item.deptId[len - 1];
            s.deptId = item.deptId[len - 1];
            s.isResponse = item.isResponse ? 1 : 0;
            return s;
          } else {
            flag = true;
          }
        });
      } else {
        console.log("11");
      }
      if (flag) {
        this.$message.warning("请选择部门");
        return;
      }
      if (this.addForm.deptId == 0) {
        this.$message.warning("请选择默认部门");
        return;
      }
      delete this.addForm.password;
      modifySysUserService(this.addForm).then(
        (res) => {
          if (res.code == 10000000) {
            this.$alert("账号修改成功", "提示", {
              confirmButtonText: "确定",
            });
            this.$refs.addForm.resetFields();
            this.isAddDialogShow = false;
            this.userList = [];
            this.getSysUserAccount();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error(err);
        }
      );
    },
    /* 删除用户请求 */
    deleteSysUser() {
      if (this.userList.length != 1) {
        //未选或多选数据给出提示，只能选择一条数据进行修改
        this.$message.warning("请选择一条数据");
        // this.$confirm("请选择一条数据", "提示", {
        //   confirmButtonText: "确定",
        //   type: "warning",
        // });
        return;
      }
      let reqParam = {
        userId: this.userList[0].id,
      };
      this.$confirm("确认删除用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteSysUserService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              this.$alert("账号删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.getSysUserAccount();
              this.userList = [];
            } else if (res.code >= 20000000) {
              this.$confirm(res.msg, "提示").then(() => {});
            } else {
              this.$message.error("系统异常");
            }
          },
          (err) => {
            this.$message.error("网络请求失败");
          }
        );
      });
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      this.form.pageIndex = page;
      this.getSysUserAccount();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.form.pageSize = rows;
      this.form.pageIndex = 1;
      this.getSysUserAccount();
    },
    /* 列代表多选回调 */
    handleSelectionChange(userList) {
      //  this.selectItems = val ? [val] : [];
      this.userList = userList ? [userList] : [];
    },
    /* 查询按钮回调 */
    selectClick() {
      this.form.pageIndex = 1;
      this.getSysUserAccount();
    },
    /* 重置按钮回调 */
    resetClick() {
      // this.$nextTick(()=>{

      // })
      this.$refs.form.resetFields();
      this.form.pageIndex = 1;
      this.getSysUserAccount();
    },
    /* 新增用户按钮回调 */
    addUserClick() {
      //清空addForm数据
      this.addForm = {
        name: "",
        password: "",
        displayName: "",
        jobNo: "",
        phone: "",
        email: "",
        deptId: "",
        jobIdSet: [],
        isAdmin: 0,
        jobId: 1,
        status: "1",
        remark: "",
      };
      this.deptIds = [{ deptId: [], main: true }];
      this.isAddDialogShow = true;
      this.isAddFlag = true;
    },
    /* 修改用户按钮回调 */
    updateUserClick() {
      if (this.userList.length != 1) {
        //未选或多选数据给出提示，只能选择一条数据进行修改
        this.$message.warning("请选择一条数据");
        // this.$confirm("请选择一条数据", "提示", {
        //   confirmButtonText: "确定",
        //   type: "warning",
        // });
      } else {
        this.isAddDialogShow = true;
        this.isAddFlag = false;
        this.getDetailSysUser();
        // this.$nextTick(() => {
        //   this.addForm = Object.assign({}, this.userList[0]);
        //   this.addForm.status = "1";
        //   this.addForm.id = this.userList[0].id;
        // });
      }
    },
    /* 查询单条用户详情 */
    getDetailSysUser() {
      let reqParam = {
        userId: this.userList[0].id,
      };
      getOrgIdService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.addForm = Object.assign({}, res.data);
            this.addForm.deptVOList.forEach((item) => {
              if (item.id == this.addForm.deptId) item.main = true;
              else item.main = false;
              item.deptId = [];
              item.deptId.push(item.id);
              item.isResponse=item.isResponse==1?true:false
              return item;
            });
            this.deptIds = this.addForm.deptVOList;
            this.addForm.jobIdSet = this.addForm.jobVOList.map((item) => {
              return item.id;
            });
            this.getsubListData(this.addForm.orgId);
            this.getUserOneLevelJob(this.addForm.orgId);
          } else if (res.code >= 20000000) {
            this.$confirm(res.msg, "提示").then(() => {});
          } else {
            this.$message.error("系统异常");
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 冻结用户按钮回调 */
    deleteUserClick() {
      this.deleteSysUser();
    },
    /* 修改密码按钮回调 */
    updatePwdClick() {
      if (this.userList.length > 1 || this.userList.length <= 0) {
        //未选或多选数据给出提示，只能选择一条数据进行修改
        this.$message.warning("请选择一条数据");
        // this.$confirm("请选择一条数据", "提示", {
        //   confirmButtonText: "确定",
        //   type: "warning",
        // });
      } else {
        this.$refs.PwdSetting.showPwdDialog(this.userList[0].id);
        //  this.addForm.id = this.userList[0].id;
      }
    },
    /* 指派角色按钮回调 */
    roleAssign() {
      if (this.userList.length > 1 || this.userList.length <= 0) {
        //未选或多选数据给出提示，只能选择一条数据进行修改
        this.$message.warning("请选择一条数据");
        // this.$confirm("请选择一条数据", "提示", {
        //   confirmButtonText: "确定",
        //   type: "warning",
        // });
      } else {
        this.$refs.AccountRoleAssignDialog.refreshMenu(
          this.userList[0].userCode,
          this.userList[0].roleCode
        );
      }
    },

    /* 设置部门按钮回调 */
    deptAssign() {
      if (this.userList.length > 1 || this.userList.length <= 0) {
        //未选或多选数据给出提示，只能选择一条数据进行修改
        this.$message.warning("请选择一条数据");
        // this.$confirm("请选择一条数据", "提示", {
        //   confirmButtonText: "确定",
        //   type: "warning",
        // });
      } else {
        this.$refs.AccountDeptAssignDialog.refreshMenu(this.userList[0].id);
      }
    },
    /* 用户账号变动，手机号自动出来 */
    userAccntChanged() {
      if (this.addForm.phone == "") this.addForm.phone = this.addForm.userAccnt;
    },
    /* 关闭新增弹窗 */
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    /* 新增/修改弹窗 保存按钮回调 */
    saveUserClick() {
      this.$refs.addForm.validate((res) => {
        if (res) {
          if (this.isAddFlag) {
            this.addSysUser();
          } else {
            this.modifySysUser();
          }
        }
      });
    },
    //添加一个部门
    addDeptItem() {
      this.deptIds.push({ deptId: "", main: false, isResponse: false });
    },
    //刪除一个部门
    delDeptItem(index) {
      if (this.deptIds.length > 1) this.deptIds.splice(index, 1);
    },
    //获取审批流岗位下拉列表
    getUserOneLevelJob(val) {
      let reqParam = {
        orgId: val,
        // deptId:this.addForm.deptId,
        pageIndex: 1,
        pageSize: 100,
      };
      manangerStationService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.PostList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },

    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
      //  this.userList = row;
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.upload-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 500px;
}

.main-area {
  display: block;
  flex: 1;
}

.right-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.accountSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.addDialog /deep/.el-dialog__body {
  min-height: 320px;
  max-height: 420px;
  overflow: auto;
  /deep/.el-upload--picture-card {
    width: 81px;
    height: 81px;
    line-height: 90px;
  }
  .avatar {
    height: 79px;
    width: 79px;
    border-radius: 6px;
  }
}
.pwdDialog /deep/.el-dialog {
  width: 25%;
}

//----

input[type="file"] {
  display: none;
}

.content-box {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
  width: 614px;
}

.actions {
  margin-top: 1rem;
  text-align: center;
}

.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062cc;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.crop-placeholder {
  width: 100%;
  height: 100%;
  background: #acacac;
}

.cropped-image {
  width: 240px;
  height: 135px;
  border: 1px solid #acacac;
}

.cropped-image img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.empty-cropper {
  height: 300px;
  background: #acacac;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.preview-area {
  margin-left: 20px;
}
</style>
